module.exports = __webpack_public_path__ + "static/media/iap-split-sale.b146d997.png";